import { IApplicationState } from '../../types/redux';

export function abGroupReducer(state: IApplicationState['abGroup'] = 100): IApplicationState['abGroup'] {
  return state;
}
